import { useEventListener } from "./useEventListener";

/**
 * A hook that listens for a key press event and calls a callback function.
 * @param {string} key - The key to listen for.
 * @param {function} callback - The callback function to call when the key is pressed.
 */
export const useKeyPressEvent = (
  key: string,
  callback: (event: KeyboardEvent) => void,
  options?: boolean | AddEventListenerOptions,
) => {
  useEventListener(
    "keydown",
    (event) => {
      if (event.key === key) callback(event);
    },
    undefined,
    options,
  );
};
